import React, { useContext } from 'react';
import { ThemeContext } from 'providers/ThemeProvider';
import {  Card } from 'components/common';
import { Item, Content, Stats } from './styles';

export const Project = ({key,repoURL,title ,description,liveDemoURL,techStack}) => {
   
  const { theme } = useContext(ThemeContext);

  
  return (
    <Item key={key} as="a" href={repoURL} target="_blank" rel="noopener noreferrer" theme={theme}>
    <Card theme={theme}>
      <Content>
        <h4>{title}</h4>
        <p>{description}</p>
      </Content>
      <Stats theme={theme}> 
       {
         techStack.map((Tech)=>(
           <div>
             <Tech size={25}/>
           </div>
         ))
       }
         {
           liveDemoURL &&  <div>
           <span><a href={liveDemoURL} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none", color:"#6c63ff"}}>Live Demo</a></span>
         </div>
         }
       
      </Stats>
    </Card>
  </Item>

  );
};
